import React, { Component, useState } from 'react';
import { WithStyles } from 'decorators/withStyles';
import { IUser } from 'interface/user';
import { removeComment, confirmEdition, edit } from 'actionCreators/forum';
import { connect, useDispatch } from 'react-redux';
import MenuOptions from './Menu/index';
import { ICommentInformations } from '../../../interface/forum';
import { getCdnUrl, adjustDataForum } from 'utils';

import Button from '@material-ui/core/Button';
import { Grow, makeStyles, TextField } from '@material-ui/core';

const defaultImg = require('assets/img/avatar.png');
interface IState {
  textEdited: string;
  dialogText?: string;
  error?: any;
}

interface IProps {
  comment: ICommentInformations;
  classes?: any;
  user: IUser;
  removeComment: typeof removeComment;
  editComment: number;
  confirmEdition: typeof confirmEdition;
  edit: typeof edit;
  status?: string;
  history: any;
  isTitle: boolean;
}

const useStyles = makeStyles(theme => ({
  name: {
    height: 80,
    padding: 5,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#696e75',
  },
  comment: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderBottom: '1px solid #ccc',
    margin: '10px 0',
    minHeight: 140,
  },
  img: {
    width: 42,
    height: 42,
    marginRight: 10,
    borderRadius: '50%',
  },
  informations: {
    display: 'flex',
    width: '100%',
  },
  answer: {
    wordBreak: 'break-word',
    padding: '10px 0',
    color: '#555a62',
  },
  date: {
    marginTop: 5,
    fontSize: 12,
  },
  nameOptions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  textArea: {
    minHeight: 150,
    padding: 15,
    borderRadius: 5,
  },
  disabled: {
    opacity: 0.4,
  },
  textEdited: {
    display: 'none',
  },
  err: {
    color: '#ff0000',
    marginTop: 5,
  },
  input: {
    border: 'solid 1px',
    borderRadius: '4px',
    padding: '8px',
  },
}))

const CommentItem = ({comment, user, editComment, status, isTitle}: IProps) => {
  const [textEdited, setTextEdited] = useState(comment.text);
  const [error, setError] = useState({ hasErr: false, text: '' })
  const classes = useStyles();
  const dispatch = useDispatch();

  const changeText = (event: any) => {
    setTextEdited(event.target.value);
  };

  const editCommentConfirmation = () => {
    if (textEdited.trim().length < 3) {
      setError({ hasErr: true, text: 'O texto é pequeno demais, mínimo de 3 caracteres' });
      return;
    }
    if (textEdited.trim().length > 2000) {
      setError({ hasErr: true, text: 'Esse texto é grande demais, máximo de 2000 caracteres' });
      return;
    }
    setError({ hasErr: false, text: '' });

    const editedComment: Partial<ICommentInformations> = {
      id: comment.id,
      text: textEdited,
    };
    dispatch(confirmEdition(editedComment));
  };

  const cancel = () => {
    dispatch(edit(null));
    setTextEdited(comment.text);
  };
    const img = getCdnUrl(comment.user.avatar, defaultImg);

    return (
      <Grow in={true} timeout={500}>
        <div>
          <div className={`${classes.comment} ${!!comment.moderate_at ? classes.disabled : ''}`}>
            <div className={classes.name}>
              <div className={classes.informations}>
                <img src={img} alt='avatar' className={classes.img} />
                <div style={{ width: '100%' }}>
                  <div className={classes.nameOptions}>
                    <p>{comment.user.name}</p>
                    {!isTitle ? (
                      <MenuOptions
                        comment={comment}
                        status={status}
                        ownerCommentId={comment.user_id}
                        userId={user.id}
                      />
                    ) : null}
                  </div>
                  <p className={classes.date}>
                    {comment.modified_at
                      ? `Editado em ${adjustDataForum(comment.modified_at)}`
                      : adjustDataForum(comment.created_at)}
                  </p>
                </div>
              </div>
            </div>
            <div className={classes.answer}>
              {editComment === comment.id ? (
                <div>
                  <TextField
                    aria-label='Campo para escrita de um comentário para o tópico do forum'
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                    type='text'
                    value={textEdited}
                    name='comment'
                    className={classes.input}
                    placeholder='Adicionar comentário...'
                    multiline={true}
                    onChange={changeText}
                    id='forum-form-edit'
                  />
                  <Button onClick={cancel}>Cancelar</Button>
                  <Button onClick={editCommentConfirmation}>Salvar</Button>
                  {error.hasErr ? <div className={classes.err}>{error.text}</div> : ''}
                </div>
              ) : (
                <div dangerouslySetInnerHTML={{ __html: comment.text }}></div>
              )}
            </div>
          </div>
        </div>
      </Grow>
    );
}
const mapStateToProps = (state: any, ownProps: any) => {
  return {
    ...ownProps,
    editComment: state.forum.editComment,
    status: state.course.status,
  };
};
export default connect(mapStateToProps, { removeComment, confirmEdition, edit })(CommentItem);
